//import { Directive }          from '@angular/core';
import { Component, Input }     from '@angular/core';
import { Router }               from '@angular/router';
//import { AuthService }          from '../auth/ind/auth.service';
import { Referral }             from '../_models/referral';
import { ShareReferralService } from '../_services/index';
/*@Directive({
  selector: '[appReferralList]'
})*/

@Component({
  selector: 'referral-list',
  template: 
  `
    <span (click)='viewReferral()' class="handicon list-group-item" *ngIf="referral.action == 'VIEWREPORT' ">                   
      <a (click)='viewReport()' class="fa fa-bar-chart fa-lg mybtn-goldenrod" aria-hidden="true"></a> <a (click)='viewReferral()'   ng-class="hand wordWrap"> {{ referral.reflabel }} ( {{ referral.referencename }} ) from {{ referral.refcompany }} ({{ referral.refprefix }} {{ referral.reffirstname }} {{ referral.reflastname }}), completed on {{referral.finishdate}} ( {{referral.totalresponses}} responses of {{referral.totalinvited}} invites ).</a>
    </span>
    <span (click)='viewReferral()' class="handicon list-group-item" *ngIf="referral.action == 'VIEW'  || referral.action == 'PENDING'  || referral.action == 'READY' ">
      <a (click)='viewReferral()' ng-class="hand wordWrap"><small><span [ngStyle]="{'color': referral.actionColor}" >{{ referral.actionText }}</span></small><b> {{ referral.reflabel }} ( {{ referral.referencename }} ) from {{ referral.refcompany }} ({{ referral.refprefix }} {{ referral.reffirstname }} {{ referral.reflastname }}), started on  {{referral.startdate}} ( {{referral.totalresponses}} responses of {{referral.totalinvited}} invites ).</b></a>
    </span>
    <span (click)='addReferrers()' class="handicon list-group-item" *ngIf="referral.action == 'ADDREFERRERS' ">
      <a (click)='addReferrers()' ng-class="hand wordWrap"><small><span [ngStyle]="{'color': referral.actionColor}" >{{ referral.actionText }}</span></small><b> {{ referral.reflabel }} ( {{ referral.referencename }} ) from {{ referral.refcompany }} ({{ referral.refprefix }} {{ referral.reffirstname }} {{ referral.reflastname }}), started on  {{referral.startdate}} ( {{referral.totalresponses}} responses of {{referral.totalinvited}} invites ).</b></a>
    </span>
   
  `
})


export class ReferralListDirective {

  @Input()
  referral: Referral;
  action: String;
  
  constructor(
    private router: Router, 
    //private auth: AuthService, 
    private shareReferral:ShareReferralService
    ) {}

  viewReport(){
    //alert(this.referral.referralid);
    //alert("Name"+JSON.stringify(this.referral));

    if (this.referral.referralid != ""){ //alert("Referral List ViewReport: "+JSON.stringify(this.referral));
        this.shareReferral.saveSelectedReferral(this.referral);         
        this.router.navigate(["/ind/ind-report-generator"]);
    }else{
        this.router.navigate(["/ind/ind-report-demo"]);
    }

  }

  viewReferral(){
    //alert(this.referral.referralid);
    //alert("Name"+JSON.stringify(this.referral));

    if (this.referral.referralid != ""){//alert("Referral List ViewReferral: "+JSON.stringify(this.referral));
        //this.router.navigate(['/report-generator', { id: this.referral.referralid} ]);      
        this.shareReferral.saveSelectedReferral(this.referral); 
        this.router.navigate(["/ind/ind-view-referral"]);
        //this.router.navigate(["ind-add-referrers", this.referral.referralid]);   
    }else{
        this.router.navigate(["/ind/ind-home"]);
    }

  }

    addReferrers(){
    //alert(this.referral.referralid);
    //alert("Name"+JSON.stringify(this.referral));

    if (this.referral.referralid != ""){ //alert(this.referral.referralid);
        //this.router.navigate(['/report-generator', { id: this.referral.referralid} ]);      
        this.shareReferral.saveSelectedReferral(this.referral); 
        this.router.navigate(["/ind/ind-add-referrers"]);           
        //this.router.navigate(["ind-add-referrers", this.referral.referralid]);   
    }else{
        this.router.navigate(["/ind/ind-home"]);
    }

  }
}
